import ButtonIcon from '@visa/vds/button-icon';
import Icon from '@visa/vds/icon';
import ScreenReader from '@visa/vds/screen-reader';
import Wizard from '@visa/vds/wizard';
import WizardStep from '@visa/vds/wizard-step';
import WizardStepTitle from '@visa/vds/wizard-step-title';
import React from 'react';

const StoreWizard = (props) => {
    let { progressState } = props;
    return (
        <Wizard>
            {progressState.map((step, key) => (
                <WizardStep
                    key={key}
                    active={step.active}
                    completed={step.completed}
                    error={step.error && !step.active}
                    aria-current={key === 0 ? 'step' : undefined}
                >
                    <ButtonIcon
                        aria-describedby={`wizard-step-title-${key}`}
                        ariaLabel={step.label}
                        iconType="light-tiny"
                        style={{pointerEvents:"none"}}
                    >
                        {step.completed && !step.error ? <Icon name="checkmark" resolution="tiny" /> : step.label}
                        <ScreenReader>{`Step ${key + 1} of ${progressState.length}`}</ScreenReader>
                    </ButtonIcon>
                    <WizardStepTitle id={`wizard-step-title-${key}`}>{step.title}</WizardStepTitle>
                </WizardStep>
            ))}
        </Wizard>
    );

}

export default StoreWizard